import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function PageViewTracker() {
    const location = useLocation();
    useEffect(() => {
        if (location.pathname.startsWith("/admin")) return;
        const path = location.pathname + (location.search || "");
        api.post("/analytics/track", { path, referrer: document.referrer || null }).catch(() => {});
    }, [location.pathname, location.search]);
    return null;
}
